// this might not be needed anymore..=
import { isNullOrUndefined, isValidHttpUrl } from '@/utils/helpers';

import { toHtmlFromMarkdown, toMarkdownFromHtml, toTextFromHtml, toTextFromMarkdown } from '@ply-io/data-types';
import { DataTypeEvaluator } from '@ply-io/data-types';

import ParsingService from './parsing-service';

import { TEXT_BOX_FORMAT_TYPES } from './rich-text-box.const';
import { FORMULAS_KEYS } from './FormulaChip/formulas.const';
import FormulasService from './FormulaChip/formulas-service';
import { PARAGRAPH_OPEN_TAG, PARAGRAPH_CLOSE_TAG } from './format-conversion-service.const';

const evaluator = new DataTypeEvaluator();

const compareTypes = (a, b) => a.toLocaleUpperCase() === b.toLocaleUpperCase();

/* Private */
function getStandardizeLineBreaks(content) {
	return content.replaceAll('<br>', '\n').replaceAll('<br />', '\n');
}

function mapSingleLineMarkdownToHtml(content) {
	return toHtmlFromMarkdown(content).replaceAll(PARAGRAPH_OPEN_TAG, '').replaceAll(PARAGRAPH_CLOSE_TAG, '');
}

function splitToFromAndTo(functionName) {
	return functionName.split('_TO_');
}

function markdownToHtmlConversion(content) {
	const newHtml = getStandardizeLineBreaks(content)
		.split('\n')
		.map(mapSingleLineMarkdownToHtml)
		.join(`${PARAGRAPH_CLOSE_TAG}${PARAGRAPH_OPEN_TAG}`);
	return `${PARAGRAPH_OPEN_TAG}${newHtml}${PARAGRAPH_CLOSE_TAG}`;
}

function htmlToMarkdownConversion(content) {
	const newContent = ParsingService.replaceParagraphsWithLineBreaks(content, '\n');
	const newHtml = newContent.split('\n').map(toMarkdownFromHtml).join('\n');
	return newHtml;
}

function isMarkdown(str) {
	if (isValidHttpUrl(str)) {
		return false;
	}
	return evaluator.isMarkdown(str);
}

function convertToContentByType(content, functionName) {
	let result;
	const [from, to] = splitToFromAndTo(functionName);
	const markdownType = TEXT_BOX_FORMAT_TYPES.MARKDOWN;
	const htmlType = TEXT_BOX_FORMAT_TYPES.HTML;
	if (compareTypes(from, htmlType)) {
		if (compareTypes(to, markdownType)) {
			result = htmlToMarkdownConversion(content);
		} else if (compareTypes(to, htmlType)) {
			result = content;
		}
	} else if (compareTypes(from, markdownType)) {
		if (compareTypes(to, markdownType)) {
			result = content;
		} else if (compareTypes(to, htmlType)) {
			result = markdownToHtmlConversion(content);
		}
	}
	if (compareTypes(to, 'TEXT')) {
		if (compareTypes(from, markdownType)) {
			result = toTextFromMarkdown(content);
		} else {
			result = toTextFromHtml(content);
		}
	}
	return result;
}
export const privateFunctionsForTests = {
	convertToContentByType,
	markdownToHtmlConversion,
	htmlToMarkdownConversion,
};

/* Public */

function isConvertToHtml(functionName) {
	const [, to] = splitToFromAndTo(functionName);
	return compareTypes(to, TEXT_BOX_FORMAT_TYPES.HTML);
}
function convertMarkdownToHtmlForTiptapPresentation(value) {
	return isMarkdown(value) ? convertToContentByType(value, FORMULAS_KEYS.MARKDOWN_TO_HTML) : value;
}

function convertToHtmlForTiptapPresentation(value) {
	/**
	 * Guy: We have a problem, markdown detection is falsely detects html as markdown.
	 */
	// could possibly replace 'convertMarkdownToHtmlForTiptapPresentation'
	if (!evaluator.isHtml(value) && isMarkdown(value)) {
		return convertToContentByType(value, FORMULAS_KEYS.MARKDOWN_TO_HTML);
	} else if (!evaluator.isHtml(value)) {
		return convertTextToHtmlForTiptapPresentation(value);
	}
	return value;
}

function convertHtmlToMarkdownForTiptapPresentation(value) {
	return convertToContentByType(value, FORMULAS_KEYS.HTML_TO_MARKDOWN);
}

function convertMarkdownToTextForTiptapPresentation(value) {
	return isMarkdown(value) ? convertToContentByType(value, FORMULAS_KEYS.MARKDOWN_TO_TEXT) : value;
}

function convertTextToHtmlForTiptapPresentation(content) {
	if (isNullOrUndefined(content)) {
		content = '';
	} else if (typeof content === 'string' && content[0] === '<') {
		// Safeguard, dont add <p> to htmls!
		return content;
	}
	if (typeof content !== 'string') {
		content = String(content);
	}
	return PARAGRAPH_OPEN_TAG + content.split('\n').join(`${PARAGRAPH_CLOSE_TAG}${PARAGRAPH_OPEN_TAG}`) + PARAGRAPH_CLOSE_TAG;
}

function convertToTiptapPresentation(content, functionName, paramsList, options) {
	const [from] = splitToFromAndTo(functionName);
	if (compareTypes(from, TEXT_BOX_FORMAT_TYPES.MARKDOWN)) {
		return convertMarkdownToHtmlForTiptapPresentation(content);
	} else if (functionName.includes(FORMULAS_KEYS.VALUE_IN_FIRST_ELEMENT)) {
		const fullFormula = FormulasService.wrapWithFormula(functionName, ...paramsList);
		const { previousStepsData, replaceInsertDataStringDict } = options;
		return convertTextToHtmlForTiptapPresentation(
			FormulasService.runNoneUIFormulas(fullFormula, previousStepsData, replaceInsertDataStringDict)
		);
	} else {
		return content;
	}
}

const FormatConversionService = {
	isConvertToHtml,
	convertMarkdownToHtmlForTiptapPresentation,
	convertHtmlToMarkdownForTiptapPresentation,
	convertMarkdownToTextForTiptapPresentation,
	convertTextToHtmlForTiptapPresentation,
	convertToHtmlForTiptapPresentation,
	convertToTiptapPresentation,
};

export default FormatConversionService;
